<style src="./FieldCheck.scss" lang="scss"></style>
<template>
  <section class="mirror-field field-check">
    <fieldset>
      <label>
        <input
          type="checkbox"
          v-model="fieldData" />

        <span class="title">
          {{ title }}
        </span>
      </label>
    </fieldset>
  </section>
</template>

<script>
export default {
  name: 'FieldCheck',
  props: {
    title: '',
    value: ''
  },
  data () {
    return {
      fieldData: ''
    }
  },
  watch: {
    fieldData (v) {
      this.$emit('input', v)
    }
  },
  mounted () {
    this.fieldData = this.value
  }
}
</script>


// WEBPACK FOOTER //
// src/components/bid-mirror/mirror-form/components/field-check/FieldCheck.vue